var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.class},[_c('div',{staticClass:"dynamicimage",style:('background-image: url('+ _vm.imageurl+')')})])
}
var staticRenderFns = []

export { render, staticRenderFns }